import { Button, Typography } from '@mui/material';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';

import { useDefineUserRole } from '../../../hooks';
import { useModalCategory } from '../../../../_base/layout/categories/categoryContext';

const useStyles = makeStyles()(theme => {
  return {
    button: {
      minWidth: '200px',
      height: '44px',
      borderRadius: 22,
      fontSize: 16,
      textTransform: 'capitalize',
    },
  };
});

const ButtonAddProduct: React.FC = () => {
  const intl = useIntl();
  const { close: closeCategories } = useModalCategory();
  const { classes } = useStyles();
  const { me } = useSelector(({ profile }: any) => profile);
  const navigate = useNavigate();

  const isRoleAdmin = useDefineUserRole(me, 'ROLE_ADMIN');
  const isRoleManager = useDefineUserRole(me, 'ROLE_MANAGER');

  const goToCreateProduct = useCallback(() => {
    closeCategories();
    if (isRoleAdmin || isRoleManager) {
      navigate(`/products/create`);
    } else {
      navigate(`/products/create/company/${me?.company?.id}/${me?.company?.name}`);
    }
  }, [navigate, isRoleAdmin, isRoleManager]);

  return (
    <>
      {(isRoleAdmin || isRoleManager) && (
        <Button
          color='primary'
          variant='contained'
          className={classes.button}
          onClick={goToCreateProduct}
        >
          {intl.formatMessage({ id: 'CATEGORY.BUTTON.ADD.PRODUCT' })}
        </Button>
      )}
    </>
  );
};

export default ButtonAddProduct;
